import React from 'react';
import { ResponsiveBullet } from '@nivo/bullet';
import { getBottomAxisLayout } from './axisLayout';
import './charts.css';

const DEFAULT_MARGIN = { top: 16, right: 16, bottom: 50, left: 24 };

export default function BulletChart({
  data,
  colors,
  height = 200,
  title,
  valueFormatter,
  margin = DEFAULT_MARGIN,
  xAxisLabel = 'Progress (%)',
}) {
  const formatValue = valueFormatter || ((value) => new Intl.NumberFormat('en-US').format(Number(value) || 0));
  const theme = React.useMemo(
    () => ({
      background: '#fff',
      textColor: '#0f172a',
      fontSize: 12,
      grid: { line: { stroke: '#e2e8f0', strokeDasharray: '2 4' } },
      tooltip: { container: { background: '#0f172a', color: '#e2e8f0', borderRadius: 8, padding: 12 } },
      
    }),
    []
  );

  const legendItems = React.useMemo(
    () => [
      { label: 'Current Progress', color: colors?.measureColors?.[0] || '#7c3aed' },
      { label: 'Goal Target', color: colors?.markerColors?.[0] || '#4338ca' },
    ],
    [colors]
  );
  const axisBottomLayout = React.useMemo(() => {
    return getBottomAxisLayout({
      labels: (data || []).flatMap((d) => [...(d.ranges || []), ...(d.measures || []), ...(d.markers || [])]),
      margin,
      hasLegend: Boolean(xAxisLabel),
      minLegendOffset: 38,
    });
  }, [data, margin, xAxisLabel]);

  return (
    <div className="chart-card">
      {title && <div className="chart-title">{title}</div>}
      <div className="chart-plot" style={{ height }}>
        <ResponsiveBullet
          data={(data || []).map(d => ({ ...d, id: '' }))}
          margin={axisBottomLayout.margin}
          spacing={24}
          theme={theme}
          rangeColors={colors?.rangeColors || ['#e2e8f0', '#d9e2ec', '#c7d2fe', '#bfdbfe']}
          measureColors={colors?.measureColors || ['#7c3aed']}
          markerColors={colors?.markerColors || ['#4338ca']}
          animate
          axisBottom={{
            tickSize: 5,
            tickPadding: 8,
            legend: xAxisLabel,
            legendOffset: axisBottomLayout.legendOffset,
            legendPosition: 'middle',
            format: formatValue,
          }}
          measureBorderColor="#fff"
          measureBorderWidth={1}
        />
      </div>
      {legendItems.length > 0 && (
        <div className="chart-legend row">
          {legendItems.map((item) => (
            <div key={item.label} className="chart-legend-item">
              <span className="chart-legend-swatch" style={{ backgroundColor: item.color }} />
              <span className="chart-legend-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
